import React, { ChangeEvent } from 'react';
import { Field } from 'formik';
import { getValueByPath } from 'helpers/utils';
import { Form } from 'react-bootstrap';
import { InputProps, Props } from './CheckBox.type';

const CheckBoxField = ({ field, form, ...props }: InputProps) => {
  const isError = Boolean(
    getValueByPath(form.errors, field.name) &&
      getValueByPath(form.touched, field.name)
  );

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    form.setFieldValue(field.name, e.target.checked);
  };

  return (
    <>
      <Form.Check
        {...props}
        type="checkbox"
        checked={field.value}
        isInvalid={isError}
        onChange={handleChange}
      />
    </>
  );
};

export default function CheckBox(props: Props) {
  return (
    <>
      <Field {...props} component={CheckBoxField} />
    </>
  );
}
